import {getUrl } from './utils/utils';
import iframe from './iframe';
import {getElement} from './utils/domManager';
import defaultOptions from './defaultOptions';
import {merge} from 'lodash';

/**
 * Facade for manipulating CleverMaps iframes and authentication
 * @param {string} host url host, common for all iframes
 * @param {string} accessToken access token to be sent to CM BE in Authorization header
 * @returns {Object}
 */
const sdk = (host = 'https://secure.clevermaps.io/', accessToken) => {
    const hostUrl = getUrl(host);

    /**
     * Factory for creating iframe objects
     * @param {string} urlPath path
     * @returns {Object} iframe object
     */
    function createIframe(urlPath, customOptions = {}) {
        const options = merge({}, defaultOptions, customOptions);
        return iframe(hostUrl, urlPath, options, accessToken);
    }

    /**
     * Renders iframe into the element as a child
     * @param {string|Object} container dom element or element id
     * @param {Object} iframe object
     * @returns {boolean}
     */
    function renderIframe(container, iframe) {
        let containerElement;
        try {
            containerElement = getElement(container);
        } catch {
            console.error('CM SDK: Can not render iframe. Unknown id or invalid dom element.');
            return false;
        }


        iframe.render(containerElement);

        let init = false;
        iframe.message.addEmbeddingReadyListener((isReady) => {
            if (isReady && !init) {
                iframe.message.setEmbeddingSettings();
                init = true;
            }
        });

        return true;
    }

    /**
     * Removes iframe from the element
     * @param {string|Object} container dom element or element id
     * @param {Object} iframe object
     * @returns {boolean}
     */
    function removeIframe(container, iframe) {
        let containerElement;
        try {
            containerElement = getElement(container);
        } catch {
            console.error('CM SDK: Can not remove iframe. Unknown id or invalid dom element.');
            return false;
        }

        iframe.remove(containerElement);
        return true;
    }

    return {
        createIframe,
        renderIframe,
        removeIframe
    };
};

export default sdk;
